import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useCart } from '../../contexts/CartContext';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';

const SuccessPage = () => {
  const [searchParams] = useSearchParams();
  const { clearCart } = useCart();
  const sessionId = searchParams.get('session_id');
  const paymentMethod = searchParams.get('payment_method');
  const orderId = searchParams.get('order_id');

  useEffect(() => {
    // Clear the cart after successful payment (online or pay on delivery)
    if (sessionId || paymentMethod === 'pay_on_delivery' || orderId) {
      clearCart();
    }
  }, [sessionId, paymentMethod, orderId, clearCart]);

  const isPayOnDelivery = paymentMethod === 'pay_on_delivery';

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow flex flex-col items-center justify-center bg-white px-4 mb-10">
        <div className="text-center max-w-2xl mx-auto">
          {/* Success Icon */}
          <div className="mb-6">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto">
              <svg className="w-10 h-10 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            </div>
          </div>

          {/* Success Message */}
          <h1 className="text-3xl font-bold text-green-600 mb-4">
            {isPayOnDelivery ? 'Commande confirmée !' : 'Paiement réussi !'}
          </h1>
          
          <p className="text-gray-600 mb-6 text-lg">
            {isPayOnDelivery 
              ? 'Votre commande a été placée avec succès. Vous recevrez un email de confirmation dans les prochaines minutes.'
              : 'Merci pour votre commande. Vous recevrez un email de confirmation dans les prochaines minutes.'
            }
          </p>

          {/* Payment Method Specific Information */}
          {isPayOnDelivery ? (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6">
              <h2 className="text-lg font-semibold text-blue-900 mb-3">
                Paiement à la livraison
              </h2>
              <div className="text-left space-y-2 text-sm text-blue-800">
                <p>• Vous paierez en espèces lors de la réception de votre commande</p>
                <p>• Notre équipe de livraison vous contactera pour confirmer la date et l'heure</p>
                <p>• Préparez le montant exact : <strong>{searchParams.get('total') || '0.00'} TND</strong></p>
                <p>• Livraison estimée : 3-5 jours ouvrables</p>
              </div>
            </div>
          ) : (
            <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-6">
              <h2 className="text-lg font-semibold text-green-900 mb-3">
                Détails de la transaction
              </h2>
              <div className="text-left space-y-2 text-sm text-green-800">
                <p>• Paiement traité avec succès via Flouci</p>
                <p>• Vous recevrez un reçu par email</p>
                <p>• Livraison estimée : 5-10 jours ouvrables</p>
              </div>
            </div>
          )}

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => window.location.href = '/home'}
              className="bg-yellow-600 hover:bg-yellow-700 text-white font-medium py-3 px-6 rounded-lg transition-colors"
            >
              Retour à l'accueil
            </button>
            <button
              onClick={() => window.location.href = '/shop'}
              className="bg-gray-600 hover:bg-gray-700 text-white font-medium py-3 px-6 rounded-lg transition-colors"
            >
              Continuer les achats
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default SuccessPage; 